import { TReactSetState, TUseTranslationTfn } from "../../data/AppType";
import { EVENT_REGISTRATION } from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  prepareMessageFromParams,
  sweetAlertError,
  sweetAlertSuccess,
} from "../../utils/AppFunctions";
import { SweetAlertError } from "../common/sweetAlertError";

import * as Yup from "yup";

export interface IRegistrationForm {
  event_id: number | null;
  first_name: string;
  last_name: string;
  participant_age: string;
  email_address: string;
  mobile_number?: string;
}

export const initialValuesEventForm = (id: number) => {
  return {
    event_id: id,
    first_name: "",
    last_name: "",
    participant_age: "",
    email_address: "",
    mobile_number: undefined,
  };
};

export const registrationFormValidationSchema = (t: TUseTranslationTfn) =>
  Yup.object().shape({
    first_name: Yup.string().required(
      prepareMessageFromParams(t("error_message_required"), [
        ["fieldName", t("first_name")],
      ])
    ),
    last_name: Yup.string().required(
      prepareMessageFromParams(t("error_message_required"), [
        ["fieldName", t("last_name")],
      ])
    ),
    email_address: Yup.string()
      .test(
        "is-email-or-mobile",
        prepareMessageFromParams(t("error_message_required"), [
          ["fieldName", t("email")],
        ]),
        function (value) {
          const { mobile_number } = this.parent;
          return !!value || !!mobile_number;
        }
      )
      .email(t("error_message_invalid_email")),
    mobile_number: Yup.string().test(
      "is-email-or-mobile",
      prepareMessageFromParams(t("error_message_required"), [
        ["fieldName", t("mobile_number")],
      ]),
      function (value) {
        const { email_address } = this.parent;
        return !!value || !!email_address;
      }
    ),
  });

export const handleSubmitRegistrationForm = async (
  values: IRegistrationForm,
  setShowRegistrationModal: TReactSetState<boolean>
) => {
  try {
    const resultRegistration = await EVENT_REGISTRATION(values);
    if (resultRegistration.code === DEFAULT_STATUS_CODE_SUCCESS) {
      setShowRegistrationModal(false);
      sweetAlertSuccess(resultRegistration.message);
    } else {
      sweetAlertError(resultRegistration.message);
    }
  } catch (e: any) {
    SweetAlertError(e?.resultBlogs?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  }
};
